






































































































import {Prop} from "vue-property-decorator";
import {Component, Vue} from '@/shared/component';

import storeLivraison, {LivraisonFilter} from '@/stores/modules/livraison';

import CrudList from '@/components/Crud/List.vue';
import TableHead from '@/components/Paginate/TableHead.vue';
import TableCell from '@/components/Paginate/TableCell.vue';
import Checked from '@/components/Checked.vue';
import {Stored} from "vue-stored-prop-decorator/index";
import {EssenceAchat, Livraison} from "@/models";

@Component({
	components: {
		CrudList,
		TableHead,
		TableCell,
		Checked,
	}
})
export default class CrudLivraisonList extends Vue {

	@Prop({type: Boolean, default: true  }) private paginate;
	@Prop({type: Boolean, default: false }) private dense;

	private storeLivraison = storeLivraison;

	private async putPaid(livraison: Livraison): Promise<void> {
		await storeLivraison.dispatch('putPaid', livraison);
		await storeLivraison.dispatch('getC');
	}

	private async putFacture(livraison: Livraison): Promise<void> {
		await storeLivraison.dispatch('putFacture', livraison);
		await storeLivraison.dispatch('getC');
	}

}
